import gql from 'graphql-tag'

export const BLOCK_SAVE = gql`
    mutation blockSave($input: BlockSaveInput!) {
        blockSave(input: $input) {
            id
            identifier
            createdAt
            deletedAt
            lastPublished
            currentVersion {
                id
                name
                state
                contents
                updatedBy {
                    id
                    name
                }
                createdAt
                updatedAt
            }
        }
    }
`
